<template>
  <div class="login-container">
    <login-form
      :base-error-text="baseError.text"
      :on-successful-login="handleLogin"
    />
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm";

import { useAuthStore } from "@/stores/authStore";

export default {
  name: "LoginPage",
  components: { LoginForm },
  data() {
    return {
      baseError: { visible: false, text: "Возникла ошибка" },
    };
  },
  methods: {
    async handleLogin() {
      const authStore = useAuthStore();

      const returnUrl = authStore.returnUrl;

      if (returnUrl) {
        await this.$router.push(returnUrl);
      } else {
        await this.$router.push({ name: "Home" });
      }

      authStore.clearReturnUrl();

      if (
        this.$route.fullPath === returnUrl ||
        this.$route.name === "Home"
      ) {
        window.location.reload();
      }
    },
  },
  created() {
    document.cookie =
      "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    document.cookie =
      "userId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    document.cookie =
      "exp=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    localStorage.clear();
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .login-container {
    height: 100vh;
    background-color: var(--color-dark);
  }
}
</style>
